import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

function CtaBanner() {
  return (
    <section className="cta-section" id="contact">
      <div className="cta-inner">
        <div className="reveal cta-box">
          <div className="cta-grain" />
          <div className="cta-blob" />
          <div className="cta-content">
            <div className="cta-text">
              <h2>Ready to import from India to the UK?</h2>
              <p>
                Tell us what you need — product list, quantities, and preferred packing.
                We&apos;ll send a wholesale quote with India-to-UK freight options,
                lead times, and full export documentation. MOQ 50&nbsp;kg per product.
              </p>
            </div>
            <div className="cta-action">
              <Link to="/contact" className="cta-btn">
                Get a UK Import Quote
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaBanner;
